module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "section level1",
    attrs: {
      "id": "قبل-عشرين-سنة"
    }
  }, [_c('h1', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قبلَ عشرينَ سنةً")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("في ذلك اليوم كانَت منيرة تقف أمامَ والدِها صامتةً بعد أن استمرَّ إضرابها عن الطّعام أيّامًا وعجز رفعت الهاشم من إقناعها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تفعلي بنفسك هذا من أجل ذلك السرسري.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نظرت إليه وقالت:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ذلك الّذي تنعتُه بالسرسريّ اخترتُه ليكون شريك حياتي، وأنتَ تعرف جيّدًا بأنّه رجلٌ محترمٌ ومثقَّفٌ لا ينقصه شيءٌ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أعطيك للغريب وابنُ عمّك راغبٌ بالزّواج بكِ، هو أحقُّ بك منه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أتظنُّ أنّك ستضمن له السّعادة بهذا الزّواج؟ أهكذا تظنّ أنّ شقيقك سيرتاح في قبرهِ يا أبي؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("نهضَ رفعت باشا من مكانه، وأخذَ يخاطبُها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أجبرَك على الزّواج من ابن أخي، لكن أخبريني كيفَ ستتزوجين بذلك الرجل؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("لم تصدّق مُنيرةُ ما سمعتهُ من والِدها فقد بَدَا لها أنَّ قلبَه لَانَ ناحيتَها:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يكفيني تفهُّمك ورضاكَ عنّي يا أبي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لستُ راضيًا، ولا تتوقّعي منّي أيّ دعمٍ، بلْ خَافِي من رَدّة فعل عزيز لأنّني لن أعارضَه بأيّ قرارٍ يتّخذه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("كانتِ السّاعة تشيرُ إلى السّادسة مساءً في قصر رفعت باشا الهاشم، وجميعُ مَنْ في القصر في حالة ترقُّبٍ؛ متى تأتي منيرة لتُطمئنَ الباشا على حفيدهِ، فقَلَقُه بَدَأ يؤثّر على أفراد العائلة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- هذه الفتاة ماتت مشاعِرها وأصبحَت غيرَ مراعيةٍ يا رياضُ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ المُحامي بسخرية: صحيح، هي غير مراعيةٍ كما قلتَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أكمل الباشا: ألا يوجد هاتفٌ في بيت الحمداني لتتّصل وتُخبِرنا عن سبب تأخّرها هكذا؟!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("ردّ رياضٌ: عن سبب تأخّرها! أو لتُريح قلبك وتطمئنكَ على حفيدكَ، وتخلِّصنا من توتّركَ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنا لستُ متوترًا!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أنتَ تُكابرُ، ارفع سمّاعة الهاتف واسأل عن أحوالِ حفيدك لترتاحَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أتّصلَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- يا لكَ من عجوزٍ عنيدٍ!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا فائدة مِنك، هيّا اذهب إلى بيتك، فوجودك لا يُفيدني بشيء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لن أذهب إلى أيّ مكانٍ، بل سأبقى لكن ليس معك هُنا، سأذهب إلى الصّالة وأجلس مع أبناء صديقي العنيد، وأشرب قهوتي من يَدَي جميلتي علياء.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- قهوتُها ليسَت لذيذةً.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- بالنّسبة لي هي أَلذُّ قهوةٍ ذُقْتها في حياتي.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- حسنًا، حسنًا، قبل أن تذهب نادِ \"مأمون\"، هو الوحيدُ الَّذي يفهمُني.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("دخل \"مأمونُ\" قبل أن يخرج والدُه السّيد \"رياض\" من المكتب:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- ألم أقُل لكَ إنَّه الوحيد الَّذي يفهمني؟ لقَد شعرَ بحاجَتي له وحضر دون أن أخبره، تعلَّم مِن ابنك يا رياض!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لماذا أتعلّم منه؟ أينقصكَ مجنونٌ آخَر في حياتك؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("قالها ثمَّ خرج وأغلق الباب وراءه.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("أشار له رفعَت بيده ليقترب منه. اقترب مأمون وجلس أمامه وقال:")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقلقْ، إنّها الحُمّى كالعادة.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تخبّئ عنّي شيئًا.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وما الَّذي سأخفيه؟ أقسمُ إنّها الحُمّى المعتادة الَّتي تُصيبُه مرارًا دون سبب.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- تبًّا لهذه الحُمّى الَّتي لا تفارق حفيدي! لقد أرهَقَته.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقلق، سيُشْفى خلال يومين.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- وماذا عن موضوعِنا؟")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- كلُّ شيءٍ كما أردتَ.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- أريدُهم أن يَبِيتوا اللَّيلة في السّجن يا مأمون!")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_vm._v("- لا تقلق.")])]), _vm._v(" "), _c('p', [_c('span', {
    attrs: {
      "dir": "rtl"
    }
  }, [_c('br')])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-49f48c78","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/text/ch009.vue
// module id = 84
// module chunks = 0